import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const FAILURE_REASON_LABELS = {
    // Phase 9 RUN-05..07 (runtime / model / channel)
    api_key_not_configured: "api_key_not_configured",
    model_id_not_allowlisted: "model_id_not_allowlisted",
    token_budget_exceeded: "token_budget_exceeded",
    rate_limit_exhausted: "rate_limit_exhausted",
    channel_not_configured: "channel_not_configured",
    // Phase 9 RUN-12 (tool validation)
    tool_validation_failed: "tool_validation_failed",
    // #2852 / #2862 (migration 092) — a strict template failure that fails the job (on_entry, or a terminal
    // state's outputs:). Sentence-case like home_tenant_binding_unratified; the raw code stays in `title`.
    template_resolution_failed: "Template resolution failed",
    // Phase 17 D-TOOL-04 (email)
    recipient_not_allowed: "recipient_not_allowed",
    template_not_found: "template_not_found",
    acs_api_timeout: "acs_api_timeout",
    acs_api_error: "acs_api_error",
    dkim_misaligned: "dkim_misaligned",
    guardrail_failed_pending_approval: "guardrail_failed_pending_approval",
    channel_unknown_error: "channel_unknown_error",
    // Phase 18 D-TOOL-02 (teams)
    recipient_not_found_in_tenant: "recipient_not_found_in_tenant",
    recipient_mismatch_with_persisted_conversation: "recipient_mismatch_with_persisted_conversation",
    bot_not_authorized_in_tenant: "bot_not_authorized_in_tenant",
    proactive_send_failed: "proactive_send_failed",
    tenant_app_not_consented: "tenant_app_not_consented",
    job_terminal_no_outbound_allowed: "job_terminal_no_outbound_allowed",
    scope_not_implemented: "scope_not_implemented",
    // Phase 19 D-ERR-01 (slack)
    bot_not_in_channel: "bot_not_in_channel",
    slack_app_uninstalled: "slack_app_uninstalled",
    channel_not_found: "channel_not_found",
    thread_mismatch_with_persisted_conversation: "thread_mismatch_with_persisted_conversation",
    channel_mismatch_with_persisted_conversation: "channel_mismatch_with_persisted_conversation",
    slack_rate_limited: "slack_rate_limited",
    slack_api_error: "slack_api_error",
    // Phase 110 — home-tenant binding not yet ratified by an operator.
    home_tenant_binding_unratified: "Home-tenant binding unratified",
};
export default function FailureReasonBadge({ reason }) {
    const label = FAILURE_REASON_LABELS[reason] ?? reason;
    return (_jsxs("span", { className: "reason-badge", title: reason, children: [_jsx("span", { className: "reason-badge__dot", "aria-hidden": "true" }), label] }));
}
//# sourceMappingURL=FailureReasonBadge.js.map